import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DarkModeProvider } from '../../../providers/dark-mode-provider';
import { LucideSun, LucideMoon } from '@lucide/angular';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule, LucideSun, LucideMoon],
  template: `
    <p-button
      [rounded]="true"
      severity="secondary"
      [pTooltip]="darkMode.state() ? 'Modo claro' : 'Modo oscuro'"
      tooltipPosition="left"
      (onClick)="darkMode.notifier.toggle()"
      styleClass="theme-btn"
      [ariaLabel]="darkMode.state() ? 'Activar modo claro' : 'Activar modo oscuro'">
      @if (darkMode.state()) {
        <svg lucideSun size="16"></svg>
      } @else {
        <svg lucideMoon size="16"></svg>
      }
    </p-button>
  `,
})
export class ThemeToggleComponent {
  protected readonly darkMode = inject(DarkModeProvider);
}
